"use client"

import { Icon, Page } from '@/payload-types'
import Image from 'next/image'
import ButtonBlock from '@/payload/blocks/button-group/button-block'
import { IconComponent } from '@/components/ui/icon'
import { cn } from '@/lib/utils'
import { getBlockHtmlId } from '@/payload/fields/block-html-id'

const rowStyleMap: Record<string, string> = {
  'row-1': 'bg-theme-row-1',
  'row-2': 'bg-theme-row-2',
  'row-3': 'bg-theme-row-3',
  'row-4': 'bg-theme-row-4',
  'row-5': 'bg-theme-row-5',
}

export default function HeaderBlock({ block }: { block: Extract<NonNullable<Page['blocks']>[0], { blockType: 'header' }> }) {
  const headerBlock = block as typeof block & { animation?: (string | null) | Icon }
  const animation = headerBlock.animation
  const rowStyleClass = rowStyleMap[block.rowStyle || 'row-1'] || rowStyleMap['row-1']
  const headerImage = typeof block.image === 'object' && block.image ? block.image : null
  const imageUrl = typeof block.image === 'string'
    ? block.image
    : headerImage?.sizes?.large?.url || headerImage?.url
  const shouldRenderAnimation = !!animation

  const height = block.height === "large" ? "h-[50vh] md:h-[80vh]" : "h-[30vh] md:h-[50vh]"
  const separatorBorder = block.showBottomPaddingAndBorder
    ? 'var(--row-separator-width) solid var(--row-separator-color)'
    : undefined

  return (
    <>
      { block.header && <h1 className={"sr-only"}>{block.header}</h1>}
      <div
        id={getBlockHtmlId(block)}
        className={cn(
          block.showBottomPaddingAndBorder && 'pb-theme-section-y-mobile md:pb-theme-section-y-desktop',
          block.showBottomPaddingAndBorder && rowStyleClass,
        )}
        style={{ borderBottom: separatorBorder }}
      >
        {shouldRenderAnimation && (
          <IconComponent preserveAspectRatio={"xMidYMax slice"} icon={animation} containerClassName={cn("flex items-center justify-center overflow-hidden", height)} className="w-full h-full" />
        )}
        {imageUrl && !shouldRenderAnimation && (
          <div className={cn('relative w-full', height)}>
            <Image
              src={imageUrl}
              alt=""
              fill
              sizes="100vw"
              priority
              className={"object-cover object-center"}
            />
          </div>
        )}
        {block.buttons?.length ? (
          <div className={cn(
            "flex flex-col lg:flex-row gap-theme-md m-auto px-4 md:px-10 pb-2",
            rowStyleClass
          )}>
            {block.buttons.map((button, index) => <ButtonBlock className="md:flex-1" key={button.id ?? index} button={button} />)}
          </div>
        ) : null}
      </div>
    </>
  )
}

